import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getCmsFileById, CmsFile } from "../../apis/fileApis";

interface FileState {
  fileDetail: CmsFile | null;
  loading: boolean;
  error: string | null;
}

const initialState: FileState = {
  fileDetail: null,
  loading: false,
  error: null,
};

/* ================= THUNK ================= */

export const fetchCmsFileByIdThunk = createAsyncThunk<
  CmsFile,
  string,
  { rejectValue: string }
>("file/fetchCmsFileById", async (id, { rejectWithValue }) => {
  try {
    const response = await getCmsFileById(id);

    if (!response.status) {
      return rejectWithValue("Failed to fetch file");
    }

    return response.data;
  } catch (error: any) {
    return rejectWithValue(
      error?.response?.data?.message || "Failed to fetch file",
    );
  }
});

/* ================= SLICE ================= */

const fileSlice = createSlice({
  name: "file",
  initialState,
  reducers: {
    resetFileState: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCmsFileByIdThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCmsFileByIdThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.fileDetail = action.payload;
      })
      .addCase(fetchCmsFileByIdThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload ?? "Something went wrong";
      });
  },
});

export const { resetFileState } = fileSlice.actions;
export default fileSlice.reducer;
